import { toDate, toZonedTime } from 'date-fns-tz';

export const dateRangeInDays = (endDate, startDate) => {
  const oneDay = 24 * 60 * 60 * 1000;
  return Math.round((new Date(endDate) - new Date(startDate)) / oneDay);
};

// Prevents date from being off by 1 day due to time zone
export const getTimezoneOffsetDate = (date) => {
  // Parse the date string
  const parsedDate = toDate(date);

  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Convert the date to the client's time zone
  const clientTimezoneDate = toZonedTime(parsedDate, clientTimeZone);

  return clientTimezoneDate;
};

/**
 * Converts { '2020-01-01': 1, '2020-01-02': 2 } to { labels: ['Jan 20'], values: [3] }
 * and handles months, quarters, and years
 * @param data
 */
export const bucketData = (data) => {
  const labels = [];
  const values = [];

  // Sort the date keys in ascending order
  const dateKeys = Object.keys(data).sort((a, b) => new Date(a) - new Date(b));

  if (dateKeys.length === 0) {
    // Handle empty data object
    return {
      labels: [],
      values: [],
    };
  }

  const dateRange = dateRangeInDays(dateKeys[dateKeys.length - 1], dateKeys[0]);

  if (dateRange < 150) {
    // Use month units
    const buckets = {};

    dateKeys.forEach((date) => {
      const dateObj = getTimezoneOffsetDate(date);

      const year = dateObj.getFullYear();
      const month = dateObj.toLocaleDateString('en-US', { month: 'short' });
      const monthYear = `${month} '${year.toString().slice(-2)}`;

      if (!buckets[monthYear]) {
        buckets[monthYear] = 0;
      }

      buckets[monthYear] += data[date];
    });

    Object.entries(buckets).forEach(([label, value]) => {
      labels.push(label);
      values.push(value);
    });
  } else if (dateRange < 360) {
    // Use quarter units
    const buckets = {};

    dateKeys.forEach((date) => {
      const dateObj = getTimezoneOffsetDate(date);
      const year = dateObj.getFullYear();
      const quarter = Math.floor(dateObj.getMonth() / 3) + 1; // Quarters start from 1
      const quarterYear = `Q${quarter} '${year.toString().slice(-2)}`;

      if (!buckets[quarterYear]) {
        buckets[quarterYear] = 0;
      }

      buckets[quarterYear] += data[date];
    });

    Object.entries(buckets).forEach(([label, value]) => {
      labels.push(label);
      values.push(value);
    });
  } else {
    // Use year units
    const buckets = {};

    dateKeys.forEach((date) => {
      const dateObj = getTimezoneOffsetDate(date);
      const year = dateObj.getFullYear();

      if (!buckets[year]) {
        buckets[year] = 0;
      }

      buckets[year] += data[date];
    });

    Object.entries(buckets).forEach(([label, value]) => {
      labels.push(label);
      values.push(value);
    });
  }

  return {
    labels,
    values,
  };
};
